import { render, staticRenderFns } from "./Currency.vue?vue&type=template&id=108a61e7&scoped=true"
import script from "./Currency.vue?vue&type=script&lang=js"
export * from "./Currency.vue?vue&type=script&lang=js"
import style0 from "./Currency.vue?vue&type=style&index=0&id=108a61e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108a61e7",
  null
  
)

export default component.exports